import {CbJsonContactFormEmailSettings, EmailAddressRestDto} from "@/api/pharma-cms-content-block/models";
import {EmailAddressRestDtoModel} from "@/models/api/pharma-cms-content-block/EmailAddressRestDtoModel";

export class CbJsonContactFormEmailSettingsModel implements CbJsonContactFormEmailSettings {
    bcc: EmailAddressRestDto | null;
    cc: EmailAddressRestDto | null;
    subject: string;
    to: EmailAddressRestDto;



    constructor(subject: string, to: EmailAddressRestDto) {
        this.subject = subject;
        this.to = to;
        this.bcc = null;
        this.cc = null;
    }

    public static createWithDefaults(): CbJsonContactFormEmailSettingsModel {
        return new CbJsonContactFormEmailSettingsModel(
            '',
            EmailAddressRestDtoModel.createWithDefaults(),
        );
    }
}
